import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  heading: {
    paddingTop: 30,
  },
});
